/**
 * PoundIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PoundIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M6.988 21.203q-.48 0-.808-.33-.33-.33-.33-.807v-.462q0-.31.14-.566t.376-.404a5.1 5.1 0 0 0 1.517-1.512 3.7 3.7 0 0 0 .591-2.056 3.8 3.8 0 0 0-.113-.929H6.81a1.1 1.1 0 0 1-.809-.329q-.33-.33-.329-.808 0-.48.33-.808.328-.33.808-.33h.428a21 21 0 0 1-.94-1.704q-.447-.904-.447-2.224 0-2.36 1.64-3.998 1.638-1.64 3.998-1.64 1.59 0 2.864.756a5.8 5.8 0 0 1 2.034 2.01.79.79 0 0 1 .031.795 1.27 1.27 0 0 1-.633.603q-.423.174-.834.021a1.56 1.56 0 0 1-.696-.52 3.5 3.5 0 0 0-1.192-1.01 3.34 3.34 0 0 0-1.574-.38q-1.396 0-2.38.98-.983.98-.983 2.383 0 1.182.559 1.985.558.803 1.195 1.943h3.109q.48 0 .808.33.33.33.33.808t-.33.808-.808.33h-2.314q.045.2.06.438.015.24.015.49 0 1.19-.404 2.16a6.6 6.6 0 0 1-1.018 1.702h4.661q.822 0 1.347-.394.525-.395.69-1.1.105-.43.382-.731.276-.302.73-.302.48 0 .796.327.316.326.316.805 0 1.59-1.401 2.63-1.4 1.04-2.86 1.04z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PoundIcon = makeIcon('PoundIcon', PoundIconSvg)
